import React from 'react';
import { Notification } from 'ui-connect';
import { useSelector, useDispatch } from 'react-redux';
import Translate from 'components/Translate';

export default function SnackbarMessage(props) {
    const snackbarMessage = useSelector(({ systemReducer }) => systemReducer.snackbarMessage);
    const { content, show } = snackbarMessage;

    const dispatch = useDispatch();
    const closeSnackbarMessage = () => {
        dispatch({
            type: 'HIDE_SNACKBAR_MESSAGE'
        });
    };

    return (
        <Notification
            autoClose={true}
            onClose={() => {
                closeSnackbarMessage();
            }}
            open={show}
        >
            <div>
                <Translate ns={content.ns} content={content.transKey} />
            </div>
        </Notification>
    );
}
